import { Expose, plainToInstance, Type } from "class-transformer";
import {
  IsDate,
  IsNotEmpty,
  IsOptional,
  IsString,
  ValidateNested,
} from "class-validator";

/**
 * The builder partner a matched client came from (EN-5902).
 *
 * Display only: enough to badge the row and to branch per partner later, and
 * deliberately not the attribution facts a bill is built from. `displayName` is
 * the authoritative label — never rebuild it from `key`, which is entered by
 * hand per environment.
 */
export class ContractorMatchBuilderPartner {
  @Expose()
  @IsString()
  @IsNotEmpty()
  key!: string;

  @Expose()
  @IsString()
  @IsNotEmpty()
  displayName!: string;
}

export class ContractorMatchRow {
  public static from(data: Partial<ContractorMatchRow>): ContractorMatchRow {
    return plainToInstance(ContractorMatchRow, data, {
      excludeExtraneousValues: true,
    });
  }

  @Expose()
  @IsString()
  @IsNotEmpty()
  buildProjectId!: string;

  @Expose()
  @IsString()
  @IsOptional()
  clientName?: string | null;

  @Expose()
  @IsString()
  @IsOptional()
  userId?: string | null;

  @Expose()
  @IsString()
  @IsOptional()
  addressLine1?: string | null;

  @Expose()
  @IsString()
  @IsOptional()
  addressLine2?: string | null;

  @Expose()
  @IsString()
  @IsOptional()
  city?: string | null;

  @Expose()
  @IsString()
  @IsOptional()
  state?: string | null;

  @Expose()
  @IsString()
  @IsOptional()
  zipcode?: string | null;

  @Expose()
  @IsString()
  @IsOptional()
  fullAddress?: string | null;

  @Expose()
  @IsDate()
  @IsOptional()
  matchedTs?: Date | null;

  @Expose()
  @IsString()
  @IsOptional()
  projectManagerName?: string | null;

  @Expose()
  @IsString()
  @IsOptional()
  projectManagerEmail?: string | null;

  /**
   * Null for an ordinary client, and also null when identification could not
   * name one partner with confidence — the row still renders, just without a
   * pill.
   */
  @Expose()
  @IsOptional()
  @ValidateNested()
  @Type(() => ContractorMatchBuilderPartner)
  builderPartner?: ContractorMatchBuilderPartner | null;
}
